import { module } from 'modujs'

export default class extends module {
    constructor(m) {
        super(m)

        this.configs = JSON.parse(this.getData('config'));
    }

    init() {

        const cc = initCookieConsent()

        let events = {
            onFirstAction: function(user_preferences, cookie){
                // callback triggered only once on the first accept/reject action
            },

            onAccept: function (cookie) {
                // callback triggered on the first accept/reject action, and after each page load
            },

            onChange: function (cookie, changed_categories) {
                // callback triggered when user changes preferences after consent has already been given
            },
        }

        cc.run({
            ...this.configs,
            ...events
        })
    }
}
